import React from "react";
import { HelpCenterCtaV3 as HelpCenterCTA } from "./HelpCenterCTA";
import { ChatCtaV3 as ChatCTA } from "./ChatCTA";
import { PhoneCTA } from "./PhoneCTA";
import { useChatCta } from "design_system/src/hooks/useChatCta";
import classNames from "classnames";

export interface NavBarHelpCTAsProps {
    helpCenterContext: {
        visible: boolean | null;
        helpCenterSidePanelVisible: boolean | null;
    };
    isChatEnabled: boolean | null;
    providerPhoneNumber: string;
    isLoggedIn: boolean;
}

export const NavBarHelpCTAs = ({
    helpCenterContext,
    isChatEnabled,
    providerPhoneNumber,
    isLoggedIn,
}: NavBarHelpCTAsProps) => {
    const { visible: isHelpCenterEnabled } = helpCenterContext;
    const shouldShowChatCTA = useChatCta(isLoggedIn);

    const ctaConfig = {
        helpCenter: isHelpCenterEnabled,
        chat: isChatEnabled,
        phone: providerPhoneNumber,
    };

    if (ctaConfig.helpCenter && ctaConfig.chat) {
        return (
            <>
                <HelpCenterCTA className="ml-24" />
                <ChatCTA className={classNames("ml-24", { hidden: !shouldShowChatCTA })} />
            </>
        );
    }
    if (ctaConfig.chat) {
        return <ChatCTA />;
    }
    if (ctaConfig.helpCenter) {
        return <HelpCenterCTA />;
    }
    if (ctaConfig.phone) {
        return <PhoneCTA providerPhoneNumber={providerPhoneNumber} />;
    }
    return null;
};
